/**
 * 検索結果の件数を取得する関数
 */
import { internalApiClient } from "../../src/libs/axios/internalApiClient";

interface OverrideParams {
  keys: string[];
  values: string[];
}

interface SearchParams {
  form: HTMLFormElement;
  overrideParams?: OverrideParams;
}

export const fetchSearchCount = async (params: SearchParams): Promise<Number> => {
  try {
    const keys = params.overrideParams?.keys || [];
    const values = params.overrideParams?.values || [];
    const formDataObj = generateFormDataObject(params.form, keys, values);

    const response = await internalApiClient.get(`/api/internal/v1/jobs/search_count`, {
      params: formDataObj,
    });

    const count = response.data.count || 0;

    return count;
  } catch (error) {
    return 0;
  }
};

const generateFormDataObject = (
  form: HTMLFormElement,
  keys: string[],
  values: string[],
): { [key: string]: string | string[] } => {
  const formData = form ? new FormData(form) : new FormData();

  // FormDataをオブジェクトに変換
  const formDataObj = {};
  formData.forEach((value, key) => {
    // 複数選択対応（checkboxなど）
    if (formDataObj[key]) {
      if (Array.isArray(formDataObj[key])) {
        (formDataObj[key] as string[]).push(value.toString());
      } else {
        formDataObj[key] = [formDataObj[key] as string, value.toString()];
      }
    } else {
      formDataObj[key] = value.toString();
    }
  });

  // 上書きするパラメータがある場合は追加
  if (keys && values) {
    keys.forEach((key, index) => {
      formDataObj[key] = values[index];
    });
  }

  return formDataObj;
};
